"use client";

import { useState } from "react";
import { Search } from "lucide-react";
import { useRouter } from "next/navigation";
import { useI18n } from "@/i18n/I18nProvider";

export default function SearchBar() {
  const [query, setQuery] = useState("");
  const router = useRouter();
  const { t } = useI18n();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    router.push(`/services?search=${encodeURIComponent(query.trim())}`);
  };

  return (
    <div className="relative z-20 mx-5 -mt-[52px]">
      <form onSubmit={handleSubmit}>
        <div className="flex items-center h-12 rounded-full bg-white px-4 shadow-[0_10px_24px_rgba(8,56,55,0.16)]">
          <Search size={16} className="mr-2.5 shrink-0 text-text-dark/35" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={t("Search hospitals, treatments or services")}
            className="flex-1 min-w-0 bg-transparent text-[14px] text-text-dark placeholder:text-text-dark/40 outline-none"
            aria-label={t("Search hospitals, treatments or services")}
          />
        </div>
      </form>
    </div>
  );
}
